var render = function () {
  var _vm$results, _vm$results$totalAmou, _vm$results$totalAmou2, _vm$results2, _vm$results2$returned, _vm$results2$returned2, _vm$results3, _vm$results3$commissi, _vm$results3$commissi2, _ref, _vm$results4, _vm$results4$totalAmo, _vm$results5, _vm$results5$returned, _vm$results6, _vm$results6$commissi, _vm$results7, _vm$results7$totalAmo, _vm$results7$totalAmo2, _vm$results8, _vm$results8$returned, _vm$results8$returned2, _vm$results9, _vm$results9$commissi, _vm$results9$commissi2, _ref2, _vm$results10, _vm$results10$totalAm, _vm$results11, _vm$results11$returne, _vm$results12, _vm$results12$commiss;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('console-content', {
    attrs: {
      "max-width": "2056"
    }
  }, [_c('v-row', {
    staticClass: "mt-4 px-1",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "tit tit--lg text-start",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("주문 관리")]), _c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "mr-1",
    attrs: {
      "color": "secondary",
      "rounded": ""
    },
    on: {
      "click": function click($event) {
        _vm.showSearch = !_vm.showSearch;
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-filter-variant")]), _vm._v("검색필터 ")], 1)], 1)], 1), _c('v-expand-transition', [_c('v-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showSearch,
      expression: "showSearch"
    }],
    staticClass: "elevation-1 mt-2 mx-1"
  }, [_c('v-card-title', {
    staticClass: "tit tit--xs font-weight-bold"
  }, [_vm._v("검색필터")]), _c('v-card-text', {
    staticClass: "pb-0"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-date-field', {
    attrs: {
      "label": "주문일자",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.filter.createdAt[0],
      callback: function callback($$v) {
        _vm.$set(_vm.filter.createdAt, 0, $$v);
      },
      expression: "filter.createdAt[0]"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-date-field', {
    attrs: {
      "label": "주문일자",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.filter.createdAt[1],
      callback: function callback($$v) {
        _vm.$set(_vm.filter.createdAt, 1, $$v);
      },
      expression: "filter.createdAt[1]"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-2"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.searchKeys,
      "item-text": "text",
      "item-value": "value",
      "label": "검색조건",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    on: {
      "input": function input($event) {
        _vm.filter.searchValue = null;
      }
    },
    model: {
      value: _vm.filter.searchKey,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "searchKey", $$v);
      },
      expression: "filter.searchKey"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "검색어",
      "persistent-placeholder": "",
      "hide-details": "",
      "clearable": "",
      "disabled": !_vm.filter.searchKey
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.page = 1;

        _vm.search(true);
      }
    },
    model: {
      value: _vm.filter.searchValue,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "searchValue", $$v);
      },
      expression: "filter.searchValue"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.statusKeys,
      "item-text": "text",
      "item-value": "value",
      "label": "주문상태",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.filter.status,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "status", $$v);
      },
      expression: "filter.status"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.cashbillState,
      "item-text": "text",
      "item-value": "value",
      "label": "현금영수증 여부",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.filter.cashbillStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "cashbillStatus", $$v);
      },
      expression: "filter.cashbillStatus"
    }
  })], 1)], 1), ['ebook'].includes(_vm.$route.query.code) ? _c('v-row', {
    staticClass: "mt-2"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.ebookCompanies,
      "item-text": "name",
      "item-value": "_id",
      "label": "ebook업체",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    on: {
      "input": function input($event) {
        _vm.filter.searchValue = null;
      }
    },
    model: {
      value: _vm.filter._ebookCompany,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "_ebookCompany", $$v);
      },
      expression: "filter._ebookCompany"
    }
  })], 1)], 1) : _vm._e()], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function click($event) {
        _vm.page = 1;

        _vm.search(true);
      }
    }
  }, [_c('v-icon', {
    staticClass: "mt-1 mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-magnify")]), _vm._v("검색 ")], 1)], 1)], 1)], 1), _c('v-row', {
    staticClass: "mt-4 px-1",
    attrs: {
      "align": "end"
    }
  }, [_c('v-col', {
    staticClass: "tit tit--xs",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("검색수 : " + _vm._s(_vm.summary.totalCount.format()))]), _c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "green--text px-2 ml-1",
    attrs: {
      "color": "white"
    },
    on: {
      "click": _vm.excel
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-microsoft-excel")]), _vm._v("엑셀다운로드 ")], 1)], 1)], 1), _vm.results ? _c('v-row', {
    staticClass: "px-1"
  }, [_c('v-col', {
    staticClass: "tit tit--xs",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("결제금액 정산금액: ")]), _vm.filter.createdAt[0] !== '' && _vm.filter.createdAt[1] !== '' && ['ebook'].includes(_vm.$route.query.code) ? _c('v-col', {
    staticClass: "tit tit--xs",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("①총 매출액 : " + _vm._s("".concat(((_vm$results = _vm.results) === null || _vm$results === void 0 ? void 0 : (_vm$results$totalAmou = _vm$results.totalAmount[0]) === null || _vm$results$totalAmou === void 0 ? void 0 : (_vm$results$totalAmou2 = _vm$results$totalAmou.totalAmount) === null || _vm$results$totalAmou2 === void 0 ? void 0 : _vm$results$totalAmou2.format()) || 0, " \uC6D0")))]) : _vm._e(), _vm.filter.createdAt[0] !== '' && _vm.filter.createdAt[1] !== '' && ['ebook'].includes(_vm.$route.query.code) ? _c('v-col', {
    staticClass: "tit tit--xs",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("②취소금액 : " + _vm._s("".concat(((_vm$results2 = _vm.results) === null || _vm$results2 === void 0 ? void 0 : (_vm$results2$returned = _vm$results2.returnedAmount[0]) === null || _vm$results2$returned === void 0 ? void 0 : (_vm$results2$returned2 = _vm$results2$returned.totalAmount) === null || _vm$results2$returned2 === void 0 ? void 0 : _vm$results2$returned2.format()) || 0, " \uC6D0")))]) : _vm._e(), _vm.filter.createdAt[0] !== '' && _vm.filter.createdAt[1] !== '' && ['ebook'].includes(_vm.$route.query.code) ? _c('v-col', {
    staticClass: "tit tit--xs",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("③수수료 : " + _vm._s("".concat(((_vm$results3 = _vm.results) === null || _vm$results3 === void 0 ? void 0 : (_vm$results3$commissi = _vm$results3.commissionTotalAmount[0]) === null || _vm$results3$commissi === void 0 ? void 0 : (_vm$results3$commissi2 = _vm$results3$commissi.totalAmount) === null || _vm$results3$commissi2 === void 0 ? void 0 : _vm$results3$commissi2.format()) || 0, " \uC6D0")))]) : _vm._e(), _vm.filter.createdAt[0] !== '' && _vm.filter.createdAt[1] !== '' && ['ebook'].includes(_vm.$route.query.code) ? _c('v-col', {
    staticClass: "tit tit--xs",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("④정산금액(①-②-③) : " + _vm._s("".concat((_ref = (((_vm$results4 = _vm.results) === null || _vm$results4 === void 0 ? void 0 : (_vm$results4$totalAmo = _vm$results4.totalAmount[0]) === null || _vm$results4$totalAmo === void 0 ? void 0 : _vm$results4$totalAmo.totalAmount) || 0) - (((_vm$results5 = _vm.results) === null || _vm$results5 === void 0 ? void 0 : (_vm$results5$returned = _vm$results5.returnedAmount[0]) === null || _vm$results5$returned === void 0 ? void 0 : _vm$results5$returned.totalAmount) || 0) - (((_vm$results6 = _vm.results) === null || _vm$results6 === void 0 ? void 0 : (_vm$results6$commissi = _vm$results6.commissionTotalAmount[0]) === null || _vm$results6$commissi === void 0 ? void 0 : _vm$results6$commissi.totalAmount) || 0) || 0) === null || _ref === void 0 ? void 0 : _ref.format(), " \uC6D0")))]) : _vm._e()], 1) : _vm._e(), _vm.results ? _c('v-row', {
    staticClass: "px-1"
  }, [_c('v-col', {
    staticClass: "tit tit--xs",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("소비자가 정산금액: ")]), _vm.filter.createdAt[0] !== '' && _vm.filter.createdAt[1] !== '' && ['ebook'].includes(_vm.$route.query.code) ? _c('v-col', {
    staticClass: "tit tit--xs",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("①총 매출액 : " + _vm._s("".concat(((_vm$results7 = _vm.results) === null || _vm$results7 === void 0 ? void 0 : (_vm$results7$totalAmo = _vm$results7.totalAmount[0]) === null || _vm$results7$totalAmo === void 0 ? void 0 : (_vm$results7$totalAmo2 = _vm$results7$totalAmo.costTotalAmount) === null || _vm$results7$totalAmo2 === void 0 ? void 0 : _vm$results7$totalAmo2.format()) || 0, " \uC6D0")))]) : _vm._e(), _vm.filter.createdAt[0] !== '' && _vm.filter.createdAt[1] !== '' && ['ebook'].includes(_vm.$route.query.code) ? _c('v-col', {
    staticClass: "tit tit--xs",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("②취소금액 : " + _vm._s("".concat(((_vm$results8 = _vm.results) === null || _vm$results8 === void 0 ? void 0 : (_vm$results8$returned = _vm$results8.returnedAmount[0]) === null || _vm$results8$returned === void 0 ? void 0 : (_vm$results8$returned2 = _vm$results8$returned.costTotalAmount) === null || _vm$results8$returned2 === void 0 ? void 0 : _vm$results8$returned2.format()) || 0, " \uC6D0")))]) : _vm._e(), _vm.filter.createdAt[0] !== '' && _vm.filter.createdAt[1] !== '' && ['ebook'].includes(_vm.$route.query.code) ? _c('v-col', {
    staticClass: "tit tit--xs",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("③수수료 : " + _vm._s("".concat(((_vm$results9 = _vm.results) === null || _vm$results9 === void 0 ? void 0 : (_vm$results9$commissi = _vm$results9.commissionTotalAmount[0]) === null || _vm$results9$commissi === void 0 ? void 0 : (_vm$results9$commissi2 = _vm$results9$commissi.totalAmount) === null || _vm$results9$commissi2 === void 0 ? void 0 : _vm$results9$commissi2.format()) || 0, " \uC6D0")))]) : _vm._e(), _vm.filter.createdAt[0] !== '' && _vm.filter.createdAt[1] !== '' && ['ebook'].includes(_vm.$route.query.code) ? _c('v-col', {
    staticClass: "tit tit--xs",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("④정산금액(①-②-③) : " + _vm._s("".concat((_ref2 = (((_vm$results10 = _vm.results) === null || _vm$results10 === void 0 ? void 0 : (_vm$results10$totalAm = _vm$results10.totalAmount[0]) === null || _vm$results10$totalAm === void 0 ? void 0 : _vm$results10$totalAm.costTotalAmount) || 0) - (((_vm$results11 = _vm.results) === null || _vm$results11 === void 0 ? void 0 : (_vm$results11$returne = _vm$results11.returnedAmount[0]) === null || _vm$results11$returne === void 0 ? void 0 : _vm$results11$returne.costTotalAmount) || 0) - (((_vm$results12 = _vm.results) === null || _vm$results12 === void 0 ? void 0 : (_vm$results12$commiss = _vm$results12.commissionTotalAmount[0]) === null || _vm$results12$commiss === void 0 ? void 0 : _vm$results12$commiss.totalAmount) || 0) || 0) === null || _ref2 === void 0 ? void 0 : _ref2.format(), " \uC6D0")))]) : _vm._e()], 1) : _vm._e(), _c('v-data-table', {
    staticClass: "mt-2 mx-1 elevation-1",
    attrs: {
      "items": _vm.purchases,
      "headers": _vm.purchasesHeaders.filter(function (header) {
        return header.display ? header.display(_vm.$route.query.code) : true;
      }),
      "hide-default-footer": "",
      "show-select": _vm.$route.query.code === 'ebook' ? true : false,
      "item-key": "_id",
      "disable-pagination": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.order.orderNo",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return _c('div', {}, [_c('div', [_vm._v("주문번호")]), _c('div', [_vm._v(_vm._s(item.order.orderNo))]), _c('div', [_vm._v("구매번호")]), _c('div', [_vm._v(_vm._s(item.purchaseNo))])]);
      }
    }, {
      key: "item.quantity",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return _c('span', {}, [_vm._v(_vm._s(item.quantity.format()) + "개")]);
      }
    }, {
      key: "item.product",
      fn: function fn(_ref5) {
        var _item$product, _item$product2, _item$product3, _item$product4, _item$product5, _item$product6, _item$product7, _item$product8, _item$product9;

        var item = _ref5.item;
        return _c('v-layout', {
          attrs: {
            "align-center": ""
          }
        }, [_c('v-img', {
          attrs: {
            "src": item === null || item === void 0 ? void 0 : (_item$product = item.product) === null || _item$product === void 0 ? void 0 : _item$product.thumb,
            "max-width": "96",
            "max-height": "96",
            "contain": ""
          }
        }), _c('div', {
          staticClass: "pl-4"
        }, [_c('div', [_c('b', [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$product2 = item.product) === null || _item$product2 === void 0 ? void 0 : _item$product2.name))])]), _c('div', [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$product3 = item.product) === null || _item$product3 === void 0 ? void 0 : _item$product3.salePrice.format()) + "원")]), (item === null || item === void 0 ? void 0 : (_item$product4 = item.product) === null || _item$product4 === void 0 ? void 0 : _item$product4.type) == 'option' ? _c('div', [_vm._v("[" + _vm._s(item === null || item === void 0 ? void 0 : (_item$product5 = item.product) === null || _item$product5 === void 0 ? void 0 : _item$product5.optionalNames.toString()) + "] : " + _vm._s(item === null || item === void 0 ? void 0 : (_item$product6 = item.product) === null || _item$product6 === void 0 ? void 0 : _item$product6.optionalValues.toString()))]) : _vm._e(), (item === null || item === void 0 ? void 0 : (_item$product7 = item.product) === null || _item$product7 === void 0 ? void 0 : _item$product7.type) == 'addition' ? _c('div', [_vm._v("[" + _vm._s(item === null || item === void 0 ? void 0 : (_item$product8 = item.product) === null || _item$product8 === void 0 ? void 0 : _item$product8.additionalName.toString()) + "] : " + _vm._s(item === null || item === void 0 ? void 0 : (_item$product9 = item.product) === null || _item$product9 === void 0 ? void 0 : _item$product9.additionalValue.toString()))]) : _vm._e()])], 1);
      }
    }, {
      key: "item.order.buyer",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return _c('div', {}, [_c('div', [_vm._v(_vm._s(item.order.buyer.name) + " (" + _vm._s(item.order.buyer.username) + ")")]), _c('div', [_vm._v(_vm._s(item.order.buyer.phone))]), _c('div', [_vm._v(_vm._s(item.order.buyer.email))])]);
      }
    }, {
      key: "item.order.receiver",
      fn: function fn(_ref7) {
        var item = _ref7.item;
        return _c('div', {}, [_c('div', [_vm._v(_vm._s(item.order.receiver.name))]), _c('div', [_vm._v(_vm._s(item.order.receiver.phone))]), _c('div', [_vm._v(_vm._s(item.order.receiver.email))])]);
      }
    }, {
      key: "item.order.shippingAddress",
      fn: function fn(_ref8) {
        var item = _ref8.item;
        return _c('div', {}, [_c('div', [_vm._v("[" + _vm._s(item.order.shippingAddress.postcode) + "]")]), _c('div', [_vm._v(_vm._s(item.order.shippingAddress.address1))]), _c('div', [_vm._v(_vm._s(item.order.shippingAddress.address2))])]);
      }
    }, {
      key: "item.shippingInfo",
      fn: function fn(_ref9) {
        var _vm$couriers$find;

        var item = _ref9.item;
        return _c('div', {}, [_c('div', [_vm._v(_vm._s(item.shippingInfo.method))]), _c('div', [_vm._v(_vm._s(item.shippingInfo.invoiceNumber))]), _c('div', [_vm._v(_vm._s((_vm$couriers$find = _vm.couriers.find(function (courier) {
          return courier.code == item.shippingInfo.courier;
        })) === null || _vm$couriers$find === void 0 ? void 0 : _vm$couriers$find.text))])]);
      }
    }, {
      key: "item.order.cashbill.status",
      fn: function fn(_ref10) {
        var item = _ref10.item;
        return _c('div', {}, [item.order.cashbill.status ? _c('div', [_c('div', [_vm._v(_vm._s(item.order.cashbill.identityNum))]), _c('div', [_vm._v("신청")])]) : _c('div', [_vm._v("미신청")])]);
      }
    }, {
      key: "item.order.paymentAmount",
      fn: function fn(_ref11) {
        var item = _ref11.item;
        return _c('span', {}, [_vm._v(_vm._s(item.order.paymentAmount.format()) + "원")]);
      }
    }, {
      key: "item.order.totalAmount",
      fn: function fn(_ref12) {
        var item = _ref12.item;
        return _c('span', {}, [_vm._v(_vm._s(item.order.totalAmount.format()) + "원")]);
      }
    }, {
      key: "item.product.costPrice",
      fn: function fn(_ref13) {
        var item = _ref13.item;
        return _c('span', {}, [_vm._v(_vm._s(item.product.costPrice.format()) + "원")]);
      }
    }, {
      key: "item.order.pointAmount",
      fn: function fn(_ref14) {
        var item = _ref14.item;
        return _c('span', {}, [_vm._v(_vm._s(item.order.pointAmount.format()) + "원")]);
      }
    }, {
      key: "item.order.cashAmount",
      fn: function fn(_ref15) {
        var item = _ref15.item;
        return _c('span', {}, [_vm._v(_vm._s(item.order.cashAmount.format()) + "원")]);
      }
    }, {
      key: "item.order",
      fn: function fn(_ref16) {
        var item = _ref16.item;
        return _c('span', {}, [_vm._v(_vm._s(_vm.paymentWay(item)))]);
      }
    }, {
      key: "item.createdAt",
      fn: function fn(_ref17) {
        var item = _ref17.item;
        return _c('span', {}, [_vm._v(_vm._s(_vm.$dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss")))]);
      }
    }]),
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }), _c('v-pagination', {
    staticClass: "mt-3",
    attrs: {
      "length": _vm.pageCount,
      "total-visible": "11"
    },
    on: {
      "input": function input($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  }), _vm.$route.query.code === 'ebook' ? _c('v-card', {
    staticClass: "mt-4"
  }, [_c('v-card-text', {
    staticClass: "pb-0"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-sheet', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("알림삭제")])], 1), _c('v-col', [_c('v-btn', {
    attrs: {
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.confirm();
      }
    }
  }, [_vm._v("알림삭제")])], 1)], 1), _c('v-divider', {
    staticClass: "my-2"
  }), _c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-sheet', {
    attrs: {
      "width": "100"
    }
  }, [_vm._v("반품처리")])], 1), _c('v-col', [_c('v-btn', {
    attrs: {
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.complete();
      }
    }
  }, [_vm._v("반품 완료처리")])], 1)], 1)], 1)], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }